import React from 'react';
import { PageTitle } from '@/components/seo/page-title';
import { BusinessListPage } from '@/screens/business/business-list-page';

export default function TrendingScreen() {
  return (
    <>
      <PageTitle title="Trending" />
      <BusinessListPage mode="trending" title="Trending" />
    </>
  );
}
